import React, { useContext, useEffect, useState } from "react";
import CheckListFBYRadioItems from "../../../../../../blocks/FormItems/CheckListFBYRadioItems";
import {
  nursePressureSoreGradeOptions,
  pressureSoreAreaOptions,
} from "../../../../Options/systemicExamOptions";
import { yesNoOptions } from "../../../../Options/commonOptions";
import DeselectableRadioGroup from "../../../../../../blocks/FormItems/DeselectableRadioGroup";
import { hexToRgba } from "../../../../../../helpers/utility";
import { theme, Form } from "antd";

const NursePressureSore = ({ context, form }) => {
  const [refresh, setRefresh] = useState(false);
  const { formData } = useContext(context);
  const { token } = theme.useToken();
  const [checkboxes, setCheckboxes] = useState([]);
  const [otherPressureSoreName, setOtherPressureSoreName] = useState("");
  const [isOtherFocused, setIsOtherFocused] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);
  const pressureSoreData =
    formData?.examination?.pressure_sore_details ||
    formData?.systemic_examination?.pressure_sore_details;
  useEffect(() => {
    if (!isInitialized) return;
    if (!checkboxes?.others) {
      setOtherPressureSoreName("");
      form.setFieldValue(["pressure_sore_details", "others_name"], undefined);
    }
  }, [checkboxes?.others, isInitialized]);

  useEffect(() => {
    const initialCheckboxes = pressureSoreAreaOptions.reduce(
      (acc, checkbox) => {
        acc[checkbox.value] = pressureSoreData?.[checkbox.value] || false;
        return acc;
      },
      {}
    );
    setCheckboxes(initialCheckboxes);
    const existingOtherName = pressureSoreData?.others_name || "";
    setOtherPressureSoreName(existingOtherName);
    form.setFieldValue(
      ["pressure_sore_details", "others_name"],
      existingOtherName
    );

    setIsInitialized(true);
  }, [formData]);

  const leftOptions = pressureSoreAreaOptions.filter((opt) =>
    opt.label.toLowerCase().includes("left")
  );
  const rightOptions = pressureSoreAreaOptions.filter((opt) =>
    opt.label.toLowerCase().includes("right")
  );
  const otherOptions = pressureSoreAreaOptions.filter(
    (opt) =>
      !opt.label.toLowerCase().includes("left") &&
      !opt.label.toLowerCase().includes("right")
  );
  const middleSplitIndex = Math.ceil(otherOptions.length / 2);
  const otherLeft = otherOptions.slice(0, middleSplitIndex);
  const otherRight = otherOptions.slice(middleSplitIndex);

  const finalLeftOptions = [...leftOptions, ...otherLeft];
  const finalRightOptions = [...rightOptions, ...otherRight];

  return (
    <>
      <DeselectableRadioGroup
        label={"Pressure Sores"}
        name={["pressure_sore_details", "pressure_sores"]}
        options={yesNoOptions}
        form={form}
        setRefresh={setRefresh}
      />

      {form.getFieldValue(["pressure_sore_details", "pressure_sores"]) ===
        "yes" && (
        <div
          className="subsection-card"
          style={{
            borderLeft: `2px solid ${hexToRgba(token.colorPrimaryHover, 0.2)}`,
            background: "transparent",
            marginTop: "8px",
            padding: "8px 12px",
            borderRadius: "8px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "20px",
              flexWrap: "wrap",
            }}
          >
            <div style={{ flex: 1, minWidth: "250px" }}>
              <CheckListFBYRadioItems
                checkBoxOptions={finalLeftOptions}
                radioOptions={nursePressureSoreGradeOptions}
                checkboxes={checkboxes}
                setCheckboxes={setCheckboxes}
                keyChain={"pressure_sore_details"}
                form={form}
              />
            </div>

            <div style={{ flex: 1, minWidth: "250px" }}>
              <CheckListFBYRadioItems
                checkBoxOptions={finalRightOptions}
                radioOptions={nursePressureSoreGradeOptions}
                checkboxes={checkboxes}
                setCheckboxes={setCheckboxes}
                keyChain={"pressure_sore_details"}
                form={form}
              />
              {checkboxes?.others && (
                <div style={{ marginTop: "12px" }}>
                  <label style={{ fontWeight: 500 }}>
                    Specify Other Pressure Sore Area
                  </label>

                  <Form.Item
                    name={["pressure_sore_details", "others_name"]}
                    style={{ marginBottom: 0 }}
                  >
                    <input
                      type="text"
                      placeholder="Enter area name"
                      value={otherPressureSoreName}
                      onChange={(e) => {
                        const value = e.target.value;
                        setOtherPressureSoreName(value);
                        form.setFieldValue(
                          ["pressure_sore_details", "others_name"],
                          value
                        );
                      }}
                      onFocus={() => setIsOtherFocused(true)}
                      onBlur={() => setIsOtherFocused(false)}
                      style={{
                        width: "60%",
                        padding: "8px",
                        marginTop: "6px",
                        borderRadius: "6px",
                        border: isOtherFocused
                          ? `1px solid ${token.colorPrimary}`
                          : "1px solid #d9d9d9",
                        outline: "none",
                        transition: "all 0.2s ease",
                      }}
                    />
                  </Form.Item>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NursePressureSore;
